import React, { useRef } from "react";
import { X } from "lucide-react";
import { utcToUs, capitalizeFirstLetter, caregap_name, formatToDateTime,  time12HourFormat, all_insurance_options } from "../../helpers";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function SchedulerDetailsModal({
  schedulerDetails = {},
  schedulerViewModal = false,
  setSchedulerViewModal = () => {},
  previousScrollPosition=0,
}) {
  const dropdownRef = useRef(null);

  const listInsurances = all_insurance_options();
  const handleDrawerClose = () => {
    setSchedulerViewModal(false);
    window.scrollTo(0, previousScrollPosition);
  };


  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={schedulerViewModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">OTP Confirmation</Drawer.Title>
            <Drawer.Description className="sr-only">OTP confirmation modal for send email</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              <div className="docpro_modal small">
                <button
                  className="docpro_close_btn"
                  onClick={() => handleDrawerClose()}
                >
                  <X />
                </button>
                <div style={{ alignItems: "center", background: "#FFFFFF" }} className="patient-info">
                  <p className="docpro_fs_18" style={{ textAlign: "center" }}><strong> Scheduler Details </strong></p>
                  <div className="docpro_table_responsive">
                    <table className="docpro_referral_table scheduler docpro_mb_0">
                      <tbody>
                        <tr>
                          <td>
                            <strong className='docpro_fw_500' style={{ display: "inline-flex", minWidth: "115px" }}>Campaign name</strong>
                          </td>
                          <td><strong className='docpro_fw_500' style={{ display: "inline-flex", minWidth: "15px" }}>:</strong></td>
                          <td>{schedulerDetails?.campaign_name}</td>
                        </tr>
                        <tr>
                          <td><strong  className='docpro_fw_500'>Status</strong></td>
                          <td>:</td>
                          <td>
                            {schedulerDetails?.status === "active" ? 
                              <span className="docpro_green_color">Active</span>
                            :
                              <span className="docpro_red_color">Inactive</span>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_fw_500'>Target patients</strong></td>
                          <td>:</td>
                          <td>{schedulerDetails?.target_patient_type === "high_risk" ? "All high-risk patients" : capitalizeFirstLetter(schedulerDetails?.target_patient_type)}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_fw_500'>Created at</strong></td>
                          <td>:</td>
                          <td>
                            {utcToUs(schedulerDetails?.created_at)}
                          </td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_fw_500'>Last sent</strong></td>
                          <td>:</td>
                          <td>
                            {schedulerDetails?.last_send_message_at ? 
                              `${utcToUs(schedulerDetails?.last_send_message_at)}`
                            :
                              ""
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_fw_500'>Send at</strong></td>
                          <td>:</td>
                          <td>
                            {schedulerDetails?.message_send_type === "later" ? 
                              formatToDateTime(schedulerDetails?.msg_later_datetime)
                            : schedulerDetails?.message_send_type === "regularly" ? 
                              <>
                                {schedulerDetails?.regular_msg_frequency === "month" && schedulerDetails?.regular_msg_frequency_time && schedulerDetails?.regular_msg_frequency_day && (
                                  `Send message at ${time12HourFormat(schedulerDetails?.regular_msg_frequency_time)} on the first ${schedulerDetails?.regular_msg_frequency_day} of the month.`
                                )}
                                {schedulerDetails?.regular_msg_frequency === "week" && schedulerDetails?.regular_msg_frequency_time && schedulerDetails?.regular_msg_frequency_day && (
                                  `Send message at ${time12HourFormat(schedulerDetails?.regular_msg_frequency_time)} every ${schedulerDetails?.regular_msg_frequency_day}.`
                                )}
                                {schedulerDetails?.regular_msg_frequency === "year" && schedulerDetails?.regular_msg_frequency_time && schedulerDetails?.regular_msg_frequency_day && (
                                  `Send message at ${time12HourFormat(schedulerDetails?.regular_msg_frequency_time)} on the first ${schedulerDetails?.regular_msg_frequency_day} of the year.`
                                )}
                                {schedulerDetails?.regular_msg_frequency === "day" && schedulerDetails?.regular_msg_frequency_time && (
                                  `Send message at ${time12HourFormat(schedulerDetails?.regular_msg_frequency_time)} every day.`
                                )}
                              </>
                            :
                              ""
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_fw_500'>Insurances</strong></td>
                          <td>:</td>
                          <td>
                            {schedulerDetails?.insurance_ids ? (
                              listInsurances
                              .filter((insurance) => schedulerDetails?.insurance_ids?.includes(insurance.id))
                              .map((insurance) => (
                                <span key={insurance.id} className="docpro_badge docpro_badge_cyan docpro_fs_12 mr-1">
                                  {insurance.name}
                                </span>
                              ))
                            ) : 
                              "All"
                            }
                          </td>
                        </tr>
                        {schedulerDetails?.care_gaps && (
                          <tr>
                            <td><strong className='docpro_fw_500'>Care gaps</strong></td>
                            <td>:</td>
                            <td>
                              {schedulerDetails?.care_gaps?.map((gap) => (
                                <div>{caregap_name(gap.id)} - <span className={`${gap?.status === "completed" ? "docpro_green_color" : "docpro_indigo_color"}`}>{gap?.status}</span></div>
                              ))}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td><strong className='docpro_fw_500'>Message</strong></td>
                          <td>:</td>
                          <td>
                            <div className="scheduler_message_box">
                              {schedulerDetails?.message_body}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <Spacing lg={10} sm={10} />
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
